import { AccordionDetailsProps } from '@mui/material';
import { CombinedSemester, CreateEvent } from '@thro-types/events';

import { useFormikContext } from 'formik';

import { DefaultAccordion, DefaultAccordionEnum } from 'app/components';

interface SemesterProps extends AccordionDetailsProps {
  title: string;
  checked: boolean;
  elements: { value: CombinedSemester }[];
  icon: React.ReactNode;
  type: DefaultAccordionEnum.SEMESTER;
  amountSelected: number;
  active?: boolean;
}

interface RecipientProps extends AccordionDetailsProps {
  title: string;
  checked: boolean;
  elements: { entitlement: string }[];
  icon: React.ReactNode;
  type: DefaultAccordionEnum.RECIPIENT;
  amountSelected: number;
  active?: boolean;
}

type CombinedProps = SemesterProps | RecipientProps;

export function EventAccordion(props: CombinedProps) {
  const { setFieldValue, values } = useFormikContext<CreateEvent>();

  const handleClickAll = (add: boolean) => {
    if (props.type === DefaultAccordionEnum.RECIPIENT) {
      if (add) {
        setFieldValue('participantCriteria.entitlements', [
          ...new Set([
            ...values.participantCriteria.entitlements,
            ...props.elements.map(element => element.entitlement)
          ])
        ]);
      } else {
        setFieldValue('participantCriteria.entitlements', [
          ...values.participantCriteria.entitlements.filter(
            entitlement => !props.elements.find(element => element.entitlement === entitlement)
          )
        ]);
      }
    } else {
      if (add) {
        setFieldValue('participantCriteria.combinedSemesters', [
          ...new Set([
            ...values.participantCriteria.combinedSemesters,
            ...props.elements.map(element => element.value)
          ])
        ]);
      } else {
        setFieldValue('participantCriteria.combinedSemesters', [
          ...values.participantCriteria.combinedSemesters.filter(
            semester => !props.elements.find(element => element.value === semester)
          )
        ]);
      }
    }
  };

  return (
    <DefaultAccordion
      {...props}
      handleClickAll={handleClickAll}
      amountSelected={props.amountSelected}
    />
  );
}
